import type { DashboardLayoutProps } from '@classroom-ai/ui/layouts/dashboard';

import { DashboardLayout as UiDashboardLayout } from '@classroom-ai/ui/layouts/dashboard';

import { _account } from '../nav-config-account';
import { navData } from '../nav-config-dashboard';

// ----------------------------------------------------------------------

export { DashboardContent } from '@classroom-ai/ui/layouts/dashboard';

/**
 * Admin wrapper around the shared dashboard layout — injects this app's
 * nav, account menu, and workspace data via slotProps.
 */
export function DashboardLayout({ slotProps, ...other }: DashboardLayoutProps) {
  return (
    <UiDashboardLayout
      {...other}
      slotProps={{
        nav: { data: navData },
        account: { data: _account },
        ...slotProps,
      }}
    />
  );
}
